/**
 * @file modal组件对外出口
 * @author (zhaojun10)
 */

/* global document */

import React from 'react';
import ReactDOM from 'react-dom';

import { scrollWheel } from '../../common/util';
import ModalBase from './ModalBase';
import Modal from './Modal';

function confirm(config) {
    var body = document.body;
    var div = document.createElement('div');
    var close = function close(callBack) {
        if (div) {
            ReactDOM.unmountComponentAtNode(div);
            document.body.removeChild(div);
        }
        scrollWheel.scrollEnable();
        if (callBack) {
            callBack();
        }
    };
    if ('onCancel' in config) {
        config.onCancel = close.bind(this, config.onCancel);
    } else {
        config.onCancel = close;
    }
    if ('onOk' in config) {
        config.onOk = close.bind(null, config.onOk);
    } else {
        config.onOk = close;
    }
    body.appendChild(div);
    scrollWheel.scrollPrevent();
    ReactDOM.render(React.createElement(ModalBase, config), div);
}
var m = Modal;
m.confirm = confirm;
export default m;